import { get, groupBy } from 'lodash';
import moment from 'moment';
import 'moment/locale/id';

moment().locale('id');

export const DAY = {
  senin: 'monday',
  selasa: 'tuesday',
  rabu: 'wednesday',
  kamis: 'thursday',
  jumat: 'friday',
  sabut: 'saturday ',
  minggu: 'sunday',
};
export const DAYENGTOID = {
  monday: 'senin',
  tuesday: 'selasa',
  wednesday: 'rabu',
  thursday: 'kamis',
  friday: 'jumat',
  'saturday ': 'sabut',
  sunday: 'minggu',
};
export const getValueByKey = (obj, key, defaultValue) => {
  return get(obj, key, defaultValue);
};

export const constructParams = (params) => {
  const data = [];
  Object.keys(params).forEach((key) => {
    data.push(`${key}=${encodeURI(params[key])}`);
  });
  return data.length > 0 ? `?${data.join('&')}` : '';
};

export const formatIntlDate = (date) => {
  return moment(date).format('YYYY-MM-DD');
};

export const formatDate = (date) => {
  return moment(date).format('DD-MM-YYYY');
};

export const formatFullDate = (date) => {
  return moment(date).format('DD MMMM YYYY');
};

export const formatDateTime = (date) => {
  return moment(date).format('DD-DD-YYYY HH:mm');
};

export const formatFullDateTime = (date) => {
  return moment(date).format('DD MMMM YYYY HH:mm');
};

export const formatDateForInput = (dateString) => {
  const date = new Date(dateString);
  const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  const formattedDate = date.toLocaleDateString('id-ID', options);
  return formattedDate;
};
const days = {
  senin: 'monday',
  selasa: 'tuesday',
  rabu: 'wednesday',
  kamis: 'thursday',
  jumat: 'friday',
  sabtu: 'saturday',
  minggu: 'sunday',
};

export const getAllSchedule = (startDate, endDate, data) => {
  const groupByDay = groupBy(data, (dt) => dt.day);
  const flatteningSchedule = Object.keys(groupByDay).map((item) => ({
    day: item,
    schedules: groupByDay[item].map((a) => a.scheduleDetail).flat(),
  }));
  const schedules = [];
  for (
    let newDate = moment(startDate);
    newDate.isSameOrBefore(endDate);
    newDate.add(1, 'days')
  ) {
    const checkDayName = days[newDate.format('dddd').toLowerCase()];
    const checkScheduleByDay = flatteningSchedule.find(
      (item) => item.day === checkDayName,
    );
    if (checkScheduleByDay) {
      checkScheduleByDay.schedules.forEach((item) => {
        schedules.push({
          id: item.id,
          color: '#D92550',
          from: `${newDate.format('YYYY-MM-DD')} ${item.startTime}`,
          to: `${newDate.format('YYYY-MM-DD')} ${item.endTime}`,
          title: item.idSubject.name,
        });
      });
    }
  }

  return schedules;
};

export const formatDateVacation = (date) => {
  const dateTime = new Date(date);
  return Intl.DateTimeFormat('id-ID', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(dateTime);
};

export const formatDateReimburse = (date) => {
  const dateTime = new Date(date);
  return Intl.DateTimeFormat('id-ID', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }).format(dateTime);
};

export const formatToRupiah = (amount) => {
  if (!amount && amount !== 0) return 'Rp 0';

  const number = typeof amount === 'string' ? parseFloat(amount) : amount;

  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(number);
};
